var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"childrenLine",staticStyle:{"z-index":"2","position":"absolute","pointer-events":"none"},style:({
    left: _vm.left+'px',
    top: _vm.top+'px',
  }),attrs:{"width":"1","stroke":"black"}},[_c('line',{attrs:{"stroke-dasharray":"3,1","x1":"0","x2":"0","y1":"0","y2":"24"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }